import { combineReducers } from 'redux';
import { singleValueReducer } from 'store/reducerUtils';
import { setOpenPlacementChange } from './actions';

const isOpenPlacementChangeModal = singleValueReducer(setOpenPlacementChange.action, false);

export const placementChange = combineReducers({
    isOpenPlacementChangeModal,
});
